<div class="container">
  <h2 class="modal-header">
    {{ 'SHARED_COMPONENTS.DELETE_MODAL.TITLE' | translate }}
  </h2>
  <div class="content-container"></div>
  <div class="button-container" fxLayout="row" fxLayoutAlign="end">
    <num-button type="blue" class="select-button" (click)="cancel()">
      {{ 'SHARED_COMPONENTS.DELETE_MODAL.CANCEL' | translate }}
    </num-button>
    <num-button type="blue" class="select-button" (click)="confirm()">
      {{ 'SHARED_COMPONENTS.DELETE_MODAL.DELETE' | translate }}
    </num-button>
  </div>
</div>
